// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"873e0efe","527":"fd99e3db","750":"bcc507ed","787":"aa388544","877":"56669856","935":"2a16acf3"}[chunkId] + ".chunk.js";
};